import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';

import { PreventCommaDirective } from './directives/prevent-comma';
import { FormatDatePipe, FeaturePipe, NumberAbbrevPipe, SafeHtmlPipe } from './pipes';

const MAT = [MatProgressSpinnerModule, MatTooltipModule];
const DECLARATIONS = [FormatDatePipe, NumberAbbrevPipe, PreventCommaDirective, FeaturePipe, SafeHtmlPipe];

@NgModule({
    imports: [CommonModule, ...MAT],
    declarations: [...DECLARATIONS],
    exports: [...DECLARATIONS]
})
export class SharedUtilsModule {}
